import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

const date = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");
const LABEL = { confirmed: "Confirmed", in_production: "In production", shipped: "Shipped", refunded: "Refunded" };
const TONE = { shipped: "bg-[#0a0a0b] text-white", refunded: "bg-[#f3f2ec] text-[#5f5e5a]", in_production: "bg-[#ff2a85]/10 text-[#ff2a85]", confirmed: "bg-[#ff2a85] text-white" };

/** Every other order placed with the same verified email — tap one to view it. */
export const OrderHistory = ({ orders, onSelect }) => {
  if (!orders?.length) return null;
  return (
    <motion.section data-testid="order-history" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }} className="bg-[#faf9f6]/60 border border-[#e3e2dc] rounded-3xl p-6 sm:p-8">
      <p className="font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#5f5e5a]">Your other orders</p>
      <p className="font-display font-extrabold uppercase text-lg mt-1">{orders.length} more {orders.length === 1 ? "piece" : "pieces"} with this email</p>
      <ul className="mt-5 divide-y divide-[#e3e2dc]">
        {orders.map((o) => (
          <li key={o.order_ref}>
            <button data-testid={`history-order-${o.order_ref}`} onClick={() => onSelect(o)} className="group w-full flex items-center gap-4 py-4 text-left">
              <span className="font-mono-d text-xs tracking-[0.1em] w-24 shrink-0">#{o.order_ref}</span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-medium truncate">{o.product_name}</span>
                <span className="block text-[11px] text-[#5f5e5a]">{date(o.paid_at)}{o.size && o.size !== "ONE SIZE" ? ` · Size ${o.size}` : ""}{o.quantity > 1 ? ` · ×${o.quantity}` : ""}</span>
              </span>
              <span className={`font-mono-d text-[9px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-full shrink-0 ${TONE[o.status] || TONE.confirmed}`}>{LABEL[o.status] || o.status}</span>
              <ChevronRight size={14} className="text-[#5f5e5a] group-hover:text-[#ff2a85] group-hover:translate-x-0.5 transition-all" />
            </button>
          </li>
        ))}
      </ul>
    </motion.section>
  );
};
